import {Response} from "@/hooks/services/queries/types";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

type Oauth2TokenRq = {
	grant_type: "refresh_token";
	refresh_token?: string;
};

type Oauth2TokenRs = {
	access_token?: string;
	refresh_token?: string;
};

const key = "useOauth2Token";
const getPath = (): string | null => `${publicRuntimeConfig.ENV_PRODUCT_URL}/acct/api/account/oauth2Token`;

const defaultData = {
	grant_type: "refresh_token",
} as Partial<Oauth2TokenRq>;

const oauth2TokenAsync = async (props?: Oauth2TokenRq) => {
	const result = await useConfigureAxios(getPath(), {
		method: "POST",
		data: {...defaultData, ...props},
	});
	return result;
};

/** ```
 * API를 통한 로그인 상태 정보 조회
 *   `accounts.ybtour.co.kr/proxy/oauth2/token`
 * parameter
 * ```*/
const useOauth2Token = (props?: Oauth2TokenRq, options?: Partial<UseQueryOptions<Response<Oauth2TokenRs>, Error>>) =>
	useQuery({
		queryKey: [key, getPath()],
		queryFn: () =>
			useConfigureAxios({
				url: getPath(),
				method: "POST",
				data: {...defaultData, ...props},
			}).then(r => r.data),
		refetchOnWindowFocus: true,
		throwOnError: false,
		staleTime: 1000 * 60 * 30,
		...options,
	});

export default useOauth2Token;
export {getPath, oauth2TokenAsync};
export type {Oauth2TokenRq, Oauth2TokenRs};
